// pages/Unauthorized.js
import React from "react";
import { Link } from "react-router-dom";

const Unauthorized = () => (
  <div className="text-center mt-20">
    <h1 className="text-3xl font-bold text-red-600">Unauthorized</h1>
    <p className="text-gray-600 mt-4">You don’t have access to this page.</p>
    <Link to="/" className="text-blue-600 hover:underline mt-2 block">
      Go to Dashboard
    </Link>
  </div>
);

export default Unauthorized;
